export const pricing = [
    {
        name: "Trial",
        description: "",
        value: {
            monthly: 0,
            yearly: 0,
        },
        unit: "Selama 1 Minggu",
        currency: "",
        features: [
            "Tidak ada batasan User",
            "Kustomisasi Luas",
            "Antrian Real-time",
            "Multi-Layanan",
        ],
        button: {
            label: "Coba Trial",
            href: "/payment",
            color: "dark",
        },
    },
    {
        name: "Paket 6 Bulan",
        description: "",
        value: {
            monthly: 499000,
            yearly: 499000,
        },
        unit: "/ 6 bulan",
        currency: "Rp. ",
        features: [
            "Tidak ada batasan User",
            "Kustomisasi Luas",
            "Antrian Real-time",
            "Multi-Layanan",
        ],
        button: {
            label: "Mulai Sekarang",
            href: "/payment",
            color: "dark",
        },
    },
    {
        name: "Paket 12 Bulan",
        description: "",
        value: {
            monthly: 899000,
            yearly: 899000,
        },
        unit: "/ 12 Bulan",
        currency: "Rp. ",
        features: [
            "Tidak ada batasan User",
            "Kustomisasi Luas",
            "Antrian Real-time",
            "Multi-Layanan",
        ],
        button: {
            label: "Mulai Sekarang",
            href: "/payment",
            color: "dark",
        },
    },
];
